import { createFileRoute } from '@tanstack/react-router';

import { ProjectOverviewPage } from '../features/projects/detail/project-overview-page.js';

export const Route = createFileRoute('/_authed/teams/$teamId/projects/$projectId/')({
  component: ProjectOverviewPage,
});
